'use strict';

exports.XMLHttpRequest = global.XMLHttpRequest;



/*****************
 ** WEBPACK FOOTER
 ** ../~/avoscloud-sdk/lib/browserify-wrapper/xmlhttprequest-browser.js
 ** module id = 13
 ** module chunks = 0
 **/